import { Loader2, PartyPopper } from 'lucide-react'
import { useState } from 'react'
import { toast } from 'sonner'

import { employersHome } from 'rails_routes'
import { Banner, Button } from 'slab'
import { usePatchEmployersPreferences } from 'utils/web_api'

export default function HomepageOptInBanner () {
  // using state instead of mutation.isPending to maintain loading state while navigating to the new homepage after opting in
  const [isOptingIn, setIsOptingIn] = useState(false)
  const updatePreferencesMutation = usePatchEmployersPreferences()

  const optIn = () => {
    setIsOptingIn(true)
    updatePreferencesMutation.mutate({
      data: {
        homepage_enabled: true,
      },
    }, {
      onSuccess: () => {
        window.location.href = employersHome.index()
      },
      onError: () => {
        toast.error('Failed to enable homepage experience')
        setIsOptingIn(false)
      },
    })
  }

  return (
    <div className='mb-6'>
      <Banner
        type='notice'
        title='Our new homepage is coming!'
        icon={PartyPopper}
        cta={
          <Button
            onClick={optIn}
            rightIcon={isOptingIn ? () => <Loader2 className='animate-spin w-4 h-4' /> : undefined}
            disabled={isOptingIn}
          >
            Try it out
          </Button>
        }
      >
        <p>
          We're rolling out a revamped admin experience with a new control center hub that lets you see how your healthcare benefits are going at a glance.
        </p>
      </Banner>
    </div>
  )
}
